import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristtravelhistory",
  inputs: [
    {
      name: "countries_traveled",
      label: "Countries Traveled",
      placeholder: "Australia, Canada",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
      //  description: "Please write in the format Canada, Australia, England",
    },
    {
      name: "type_of_visa",
      label: "Through which you travelled ?",
      placeholder: "Visitor visa , Tourist visa",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      // description:
      //   "Write in the format Visitor visa for Australia,Tourist visa for Canada",
    },
    {
      name: "duration",
      label: "Duration of Traveling",
      placeholder:
        "30 days in June 2021 for Australia,20 days in March 2020 for Canada",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "purpose_of_travelling",
      label: "Purpose for which you Traveled in past ?",
      placeholder: "Vacation for Australia, surgery for Canada",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
    },
  ],
};

export default formFields;
